import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/iconfont.css'
import axios from 'axios'
import $config from './config'
import $util from './util/requestUtil'
import VueClipboard from 'vue-clipboard2'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import api from '@/util/api'
//import 'babel-polyfill'

Vue.component('chart', ECharts)
// import echarts from 'echarts'
import echarts from 'echarts'
import * as qiniu from 'qiniu-js'
// 
// import dataV from '@jiaminghi/data-view'
// 高德地图
import AMap from 'vue-amap'
// 引入vuex
import store from './store/index.js'
// 引入icon
import '@/assets/fonts/iconfont.css'
import '@/assets/contacts/iconfont.css'
import '@/assets/chartIcon/iconfont.css'
import '@/assets/menu_icon/iconfont.css'
import '@/assets/font_wjpc/iconfont.css'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'
import 'tinymce/icons/default/icons'
import draggable from 'vuedraggable'
import functions from '@/util/functions';
// 导入全局样式表 Lh
import './assets/css/indexT.css'
import filters from "./components/filters" //用于处理浮点数小数位数
//全局方法Vue.filter()统一注册自定义过滤器



// 电话访问 icon  
import '@/assets/font_1938827_kuqiegvr69/iconfont.css'



Object.keys(filters).forEach(key => { //返回filters对象中属性名组成的数组
	Vue.filter(key, filters[key])
})


// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.transformRequest = [function(data) {
	// console.log('axios.defaults.headers :>> ', axios.defaults.headers);
	let ContentType = axios.defaults.headers.post['Content-Type']
	// console.log('ContentType :>> ', ContentType);
	let isJsonTyep = ContentType == 'application/json;' ? true : false
	// console.log('isJsonTyep :>> ', isJsonTyep);
	axios.defaults.headers.post['Content-Type'] = isJsonTyep ? 'application/json' : 'application/x-www-form-urlencoded'
	// console.log('axios.defaults.headers.post[Content-Type] :>> ', axios.defaults.headers.post['Content-Type']);
	if (!isJsonTyep) {
		//设置axios为form-data
		let ret = ''
		for (let it in data) {
			ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
		}
		return ret
	} else {
		//设置axios为json
		return JSON.stringify(data)
	}
}]

Vue.component('draggable', draggable)

Vue.prototype.$tinymce = tinymce
Vue.use(VueTinymce)
Vue.prototype.$echarts = echarts
Vue.prototype.$config = $config;
Vue.prototype.$axios = axios;
Vue.prototype.$util = $util;
Vue.prototype.$functions = functions;
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
Vue.use(CKEditor);
Vue.use(VueClipboard)
// Vue.use(dataV)
Vue.use(qiniu)
Vue.use(AMap)

Vue.prototype.$api = api;

AMap.initAMapApiLoader({
	key: '2de8f26b655c1e999adf68de76843f0a', //高德申请的key
	plugin: [ //扩展插件
		'AMap.Autocomplete', //输入提示
		'AMap.PlaceSearch', //POI搜索
		'AMap.Scale', //比例尺
		'AMap.OverView', //地图鹰眼插件
		'AMap.ToolBar', //地图工具条
		'AMap.MapType', //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
		'AMap.PolyEditor', // 编辑 折线多，边形
		'AMap.CircleEditor', // 圆形编辑器插件
		'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
		'AMap.CitySearch',
	],
	v: '1.4.4'
})
import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';
Vue.use(VueAreaLinkage);
var vue = new Vue({
	router,
	$config,
	$util,
	store,
	render: h => h(App),
}).$mount('#app')
export default vue
